document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector(".grid-filter");

  if (grid) {
    const allowMultipleGradients = true;
    const hiddenFilterGradients = true;
    const BS_BLOCK_ID = "best-sellers-block";

    const getGutter = () => (window.innerWidth < 1024 ? 10 : 35);

    const iso = new Isotope(grid, {
      itemSelector: ".grid-item",
      layoutMode: "fitRows",
      fitRows: {
        gutter: getGutter(),
      },
      sortBy: "inventory",
      sortAscending: false,
      getSortData: {
        price: function (itemElem) {
          const priceElem = itemElem.querySelector(".price");
          if (priceElem) {
            const priceText = priceElem.textContent;
            return parseFloat(priceText.replace(/[^0-9.-]+/g, ""));
          } else {
            return 0;
          }
        },
        inventory: function (itemElem) {
          return parseInt(itemElem.getAttribute("data-inventory")) || 0;
        },
        name: ".name",
        original: function (itemElem) {
          return parseInt(itemElem.getAttribute("data-original-order"));
        },
      },
    });

    let lastTitleHeight = null;
    let lastCardHeight = null;

    function equalizeCardHeights() {
      const titles = document.querySelectorAll(".grid-item .card-title");
      const cards = document.querySelectorAll(".grid-item .card-h");

      // Isotope hides filtered-out items with display:none, and a hidden element
      // measures 0. Re-measuring in that state would drop both maximums to the
      // tallest *visible* card and every card would visibly shrink a moment after
      // the filter settles. So the heights are only measured while the whole grid
      // is on screen; a filtered grid reuses the last full measurement.
      const isFullGridVisible = Array.prototype.every.call(
        document.querySelectorAll(".grid-item"),
        el => el.offsetParent !== null,
      );

      if (isFullGridVisible || lastTitleHeight === null) {
        let maxTitleHeight = 0;
        titles.forEach(el => { el.style.minHeight = "auto"; });
        titles.forEach(el => { maxTitleHeight = Math.max(maxTitleHeight, el.offsetHeight); });

        let maxHeight = 0;
        cards.forEach(card => { card.style.minHeight = "auto"; });
        cards.forEach(card => { maxHeight = Math.max(maxHeight, card.offsetHeight); });

        lastTitleHeight = maxTitleHeight;
        lastCardHeight = maxHeight;
      }

      titles.forEach(el => { el.style.minHeight = lastTitleHeight + "px"; });
      cards.forEach(card => { card.style.minHeight = lastCardHeight + "px"; });

      iso.layout();
    }

    // Run early equalization before images load
    equalizeCardHeights();

    // Isotope positions every card absolutely, so the layout it computes is only
    // correct for the heights the cards had at that moment. Anything that changes
    // a card afterwards - the webfont swapping in and re-wrapping titles, a Vue
    // component mounting, Intelligems rewriting a price - leaves the rows
    // overlapping with nothing to correct them. These hooks re-measure.
    let relayoutTimer;
    let isRelayouting = false;

    function scheduleRelayout() {
      if (isRelayouting) return;
      clearTimeout(relayoutTimer);
      relayoutTimer = setTimeout(function () {
        isRelayouting = true;
        equalizeCardHeights();
        // equalizeCardHeights writes min-height, which the observer below would
        // otherwise read back as a fresh size change
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            isRelayouting = false;
          });
        });
      }, 150);
    }

    // The first measurement always happens with fallback font metrics.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleRelayout);
    }

    if (window.ResizeObserver) {
      const cardObserver = new ResizeObserver(scheduleRelayout);
      grid.querySelectorAll(".grid-item").forEach(function (item) {
        cardObserver.observe(item);
      });
    }

    // Reorder isotope's filteredItems to place the best sellers block at the midpoint
    let isReordering = false;
    function reorderBsBlock() {
      if (isReordering) return;
      const bsBlockEl = document.getElementById(BS_BLOCK_ID);
      if (!bsBlockEl) return;

      // Find the block item in isotope's filteredItems
      const blockItem = iso.filteredItems.find(item => item.element.id === BS_BLOCK_ID);
      if (!blockItem) return;

      // Get product items only (exclude block)
      const productItems = iso.filteredItems.filter(item => item.element.id !== BS_BLOCK_ID);
      const total = productItems.length;

      bsBlockEl.style.visibility = '';

      // Calculate midpoint aligned to row (must match the card's CSS width:
      // max-lg:w-[calc(50%-5px)] is 2 columns below the lg breakpoint, 3 above)
      const cols = window.innerWidth < 1024 ? 2 : 3;
      let mid = Math.floor(total / 2);
      mid = mid - (mid % cols);
      if (mid < cols) mid = cols;
      if (mid > total) mid = total;

      // Rebuild filteredItems with block inserted at midpoint
      iso.filteredItems = [
        ...productItems.slice(0, mid),
        blockItem,
        ...productItems.slice(mid),
      ];

      isReordering = true;
      iso.layout();
      isReordering = false;

      // Show block after reorder is done
      bsBlockEl.style.opacity = '1';
    }

    // Hide block before arrange/sort to prevent visible reorder jump
    function hideBsBlock() {
      const bsBlockEl = document.getElementById(BS_BLOCK_ID);
      if (bsBlockEl) bsBlockEl.style.opacity = '0';
    }

    function hideSkeleton() {
      var skel = document.querySelector(".grid-filter-skeleton");
      if (skel) skel.style.display = "none";
    }

    imagesLoaded(grid, function () {
      iso.layout();
      equalizeCardHeights();
      grid.style.opacity = "1";
      hideSkeleton();
    });

    // Fallback: ensure grid is visible even if imagesLoaded never fires
    setTimeout(function () {
      grid.style.opacity = "1";
      hideSkeleton();
    }, 3000);

    let isoResizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(isoResizeTimer);
      isoResizeTimer = setTimeout(function () {
        iso.options.fitRows.gutter = getGutter();
        iso.arrange();
        equalizeCardHeights();
      }, 100);
    });

    // After isotope finishes any arrange or layout, reposition the block
    iso.on("arrangeComplete", function () {
      reorderBsBlock();
    });
    iso.on("layoutComplete", function () {
      reorderBsBlock();
    });

    const filterButtons = document.querySelectorAll(".filters button");
    const sortSelects = document.querySelectorAll("#sort-select");
    const filterCounts = document.querySelectorAll(".filter-count");
    const collectionTitleActive = document.getElementById("collection-title");
    const mobileSelect = document.getElementById("mobile-collection-select");

    const filters = {
      gradients: [],
      collection: "*",
    };

    // Activate the collection filter button matching the current URL on page load
    const currentPath = window.location.pathname;
    filterButtons.forEach(btn => {
      if (
        btn.getAttribute("data-filter-group") === "collection" &&
        btn.getAttribute("data-url") === currentPath
      ) {
        btn.classList.add("active");
        const filterValue = btn.getAttribute("data-filter");
        if (filterValue) filters.collection = filterValue;
      }
    });

    filterButtons.forEach(button => {
      button.addEventListener("click", () => {
        const group = button.getAttribute("data-filter-group");
        const filterValue = button.getAttribute("data-filter");
        const isActive = button.classList.contains("active");

        if (group === "gradients") {
          if (allowMultipleGradients) {
            if (isActive) {
              button.classList.remove("active");
              filters.gradients = filters.gradients.filter(
                f => f !== filterValue,
              );
            } else {
              button.classList.add("active");
              filters.gradients.push(filterValue);
            }
          } else {
            const groupButtons = Array.from(filterButtons).filter(
              btn => btn.getAttribute("data-filter-group") === group,
            );
            groupButtons.forEach(btn => btn.classList.remove("active"));

            if (!isActive) {
              button.classList.add("active");
              filters.gradients = [filterValue];
            } else {
              filters.gradients = [];
            }
          }
        } else {
          const groupButtons = Array.from(filterButtons).filter(
            btn => btn.getAttribute("data-filter-group") === group,
          );
          groupButtons.forEach(btn => btn.classList.remove("active"));
          button.classList.add("active");
          filters[group] = filterValue;

          if (group === "collection" && collectionTitleActive) {
            collectionTitleActive.textContent = button.textContent;

            const collectionDesc = document.getElementById("collection-description");
            if (collectionDesc) {
              const desc = button.getAttribute("data-description");
              if (desc) {
                collectionDesc.textContent = desc;
                collectionDesc.classList.remove("hidden");
              } else {
                collectionDesc.textContent = "";
                collectionDesc.classList.add("hidden");
              }
            }

            const gradientButtons = document.querySelectorAll(
              'button[data-filter-group="gradients"]',
            );

            const validGradients = [];

            // Check which gradients are valid for this collection
            gradientButtons.forEach(btn => {
              const gradientValue = btn.getAttribute("data-filter");
              const testFilter = `${filterValue}${gradientValue}`;

              const matchingItems = iso.items.filter(item =>
                item.element.matches(testFilter),
              );

              if (matchingItems.length > 0) {
                validGradients.push(gradientValue);
              }
            });

            // Remove invalid gradients from active filters and deactivate buttons
            filters.gradients = filters.gradients.filter(g =>
              validGradients.includes(g),
            );

            // Deactivate gradient buttons that are not valid for this collection
            gradientButtons.forEach(btn => {
              const gradientValue = btn.getAttribute("data-filter");
              if (!validGradients.includes(gradientValue)) {
                btn.classList.remove("active");
              }
            });

            if (mobileSelect) {
              mobileSelect.value = filterValue;
            }
          }

          if (mobileSelect) {
            mobileSelect.value = filterValue;
          }
        }

        applyFilter();
      });
    });

    if (mobileSelect) {
      mobileSelect.addEventListener("change", () => {
        const selectedOption = mobileSelect.options[mobileSelect.selectedIndex];
        const filterValue = selectedOption.value;
        const group = selectedOption.getAttribute("data-filter-group");

        if (group === "collection") {
          filters[group] = filterValue;

          if (collectionTitleActive) {
            collectionTitleActive.textContent =
              selectedOption.getAttribute("data-label");
          }

          const collectionDesc = document.getElementById("collection-description");
          if (collectionDesc) {
            const desc = selectedOption.getAttribute("data-description");
            if (desc) {
              collectionDesc.textContent = desc;
              collectionDesc.classList.remove("hidden");
            } else {
              collectionDesc.textContent = "";
              collectionDesc.classList.add("hidden");
            }
          }

          filterButtons.forEach(btn => {
            if (btn.getAttribute("data-filter-group") === "collection") {
              btn.classList.toggle(
                "active",
                btn.getAttribute("data-filter") === filterValue,
              );
            }
          });
        }

        applyFilter();
      });
    }

    function applyFilter() {
      const collectionFilter = filters.collection !== "*" ? filters.collection : "";

      let combinedFilter;

      // If we have gradient filters > AND logic
      if (filters.gradients.length > 0) {
        if (collectionFilter) {
          combinedFilter = function(itemElem) {
            if (itemElem.id === BS_BLOCK_ID) return true;
            if (!itemElem.matches(collectionFilter)) {
              return false;
            }
            return filters.gradients.every(gradient => {
              const fullFilter = `${collectionFilter}${gradient}`;
              return itemElem.matches(fullFilter);
            });
          };
        } else {
          combinedFilter = function(itemElem) {
            if (itemElem.id === BS_BLOCK_ID) return true;
            return filters.gradients.every(gradient => {
              return itemElem.matches(gradient);
            });
          };
        }
      } else if (collectionFilter) {
        combinedFilter = function(itemElem) {
          if (itemElem.id === BS_BLOCK_ID) return true;
          return itemElem.matches(collectionFilter);
        };
      } else {
        // No filters - show all
        combinedFilter = "*";
      }

      hideBsBlock();
      iso.arrange({filter: combinedFilter});

      if (hiddenFilterGradients) {
        // Update gradient button visibility based on current active filters
        const gradientButtons = document.querySelectorAll(
          'button[data-filter-group="gradients"]',
        );

        gradientButtons.forEach(button => {
          const filterValue = button.getAttribute("data-filter");

          // Skip if this button is already active
          if (button.classList.contains("active")) {
            button.classList.remove("hidden");
            return;
          }

          // Create test filter combining collection + current gradients + this new gradient
          let hasMatchingItems = false;

          if (filters.gradients.length > 0) {
            // Test if adding this gradient to existing gradients would have results
            const testGradients = [...filters.gradients, filterValue];

            if (collectionFilter) {
              hasMatchingItems = iso.items.some(item => {
                if (item.element.id === BS_BLOCK_ID) return false;
                if (!item.element.matches(collectionFilter)) return false;
                return testGradients.every(gradient => {
                  const fullFilter = `${collectionFilter}${gradient}`;
                  return item.element.matches(fullFilter);
                });
              });
            } else {
              hasMatchingItems = iso.items.some(item => {
                if (item.element.id === BS_BLOCK_ID) return false;
                return testGradients.every(gradient => {
                  return item.element.matches(gradient);
                });
              });
            }
          } else {
            const testFilter = collectionFilter
              ? `${collectionFilter}${filterValue}`
              : filterValue;

            hasMatchingItems = iso.items.some(item => {
              if (item.element.id === BS_BLOCK_ID) return false;
              return item.element.matches(testFilter);
            });
          }

          if (!hasMatchingItems) {
            button.classList.add("hidden");
          } else {
            button.classList.remove("hidden");
          }
        });

        // Show all gradient buttons if no filters are active
        if (filters.collection === "*" && filters.gradients.length === 0) {
          gradientButtons.forEach(button => button.classList.remove("hidden"));
        }
      }

      // Exclude block from product count
      const filteredItems = iso.filteredItems.filter(
        item => item.element.id !== BS_BLOCK_ID,
      ).length;
      if (filterCounts) {
        filterCounts.forEach(
          f => (f.textContent = `${filteredItems} Products`),
        );
      }

      const noProductsMessage = document.getElementById("no-products-message");
      if (noProductsMessage) {
        if (filteredItems === 0) {
          noProductsMessage.classList.remove("hidden");
        } else {
          noProductsMessage.classList.add("hidden");
        }
      }

      equalizeCardHeights();
    }

    sortSelects.forEach(select => {
      select.addEventListener("change", () => {
        const selectedOption = select.value.split("-");
        const sortValue = selectedOption[0];
        const sortAscending = selectedOption[1] === "true";
        // Sync all sort selects
        sortSelects.forEach(s => { s.value = select.value; });
        hideBsBlock();
        iso.arrange({sortBy: sortValue, sortAscending: sortAscending});
        equalizeCardHeights();
      });
    });

    // A native <select> list is drawn outside the page, where it opened, so a
    // scroll while it is open leaves it floating away from the select.
    // Dropping focus closes it.
    window.addEventListener(
      "scroll",
      () => {
        sortSelects.forEach(s => {
          if (document.activeElement === s) s.blur();
        });
      },
      {passive: true},
    );

    window.addEventListener("load", () => {
      // Exclude block from product count
      const filteredItems = iso.filteredItems.filter(
        item => item.element.id !== BS_BLOCK_ID,
      ).length;
      if (filterCounts) {
        filterCounts.forEach(
          f => (f.textContent = `${filteredItems} Products`),
        );
      }

      const pathname = window.location.pathname;
      let buttonIndex;

      if (pathname.includes("/adult-dogs")) buttonIndex = 2;
      else if (pathname.includes("/cat")) buttonIndex = 3;
      else if (pathname.includes("/puppies-moms")) buttonIndex = 4;
      else if (pathname.includes("/specialty-diet-blends")) buttonIndex = 5;
      else if (pathname.includes("/variety-packs")) buttonIndex = 6;

      if (buttonIndex !== undefined) {
        const activeButton = filterButtons[buttonIndex - 1];
        if (activeButton) activeButton.click();
      }

      equalizeCardHeights();
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        equalizeCardHeights();
      }, 200);
    });
  }
});
